module.exports = __webpack_public_path__ + "img/breathing_exercises.136ffed8.jpg";